import { render, staticRenderFns } from "./boxGaugeModification.vue?vue&type=template&id=4cbc4479&scoped=true&"
import script from "./boxGaugeModification.vue?vue&type=script&lang=js&"
export * from "./boxGaugeModification.vue?vue&type=script&lang=js&"
import style0 from "./boxGaugeModification.vue?vue&type=style&index=0&id=4cbc4479&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbc4479",
  null
  
)

export default component.exports